import React from 'react';
import {FormGroup} from '@blueprintjs/core';

import {SimpleSelect} from '../../select';
import {ACTION_OPTIONS} from './constants';

interface ISelectActionProps {
  selected: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  show?: boolean;
}

const SelectAction = ({
  selected,
  onChange,
  disabled = false,
  show = true,
}: ISelectActionProps) => {
  if (!show) {
    return null;
  }

  return (
    <FormGroup label="Action" inline={true}>
      <SimpleSelect
        selected={selected}
        disabled={disabled}
        onChange={onChange}
        options={ACTION_OPTIONS}
        buttonProps={{
          minimal: true,
          fill: true,
          small: true,
          outlined: true,
        }}
        popoverProps={{
          usePortal: true
        }}
      />
    </FormGroup>
  );
};

export default SelectAction;
